module.exports = __webpack_public_path__ + "static/android-icon-192x192-7825f5a73da1c3c583f092e04faa2cda.png";